import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hours-table" }
const _hoisted_2 = { class: "project-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "week-day-date" }
const _hoisted_5 = { class: "projects-column" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["workedHours"]
const _hoisted_8 = ["onUpdate:modelValue", "onChange"]
const _hoisted_9 = ["phase"]
const _hoisted_10 = ["workedHours"]
const _hoisted_11 = ["onUpdate:modelValue", "onChange"]
const _hoisted_12 = {
  class: "projects-column",
  style: {"position":"sticky","bottom":"-1px"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", {
  class: "project-name",
  style: {"cursor":"default"}
}, "TOTAL", -1)
const _hoisted_14 = ["totalForDay"]
const _hoisted_15 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("thead", null, [
        _createElementVNode("th", _hoisted_2, [
          _createElementVNode("div", null, [
            _createTextVNode("Projetos "),
            _withDirectives(_createElementVNode("input", {
              class: "filter-input",
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event))
            }, null, 512), [
              [_vModelText, _ctx.search]
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (weekDay, index) => {
          return (_openBlock(), _createElementBlock("th", {
            key: index,
            class: "day-header"
          }, [
            _createTextVNode(_toDisplayString(weekDay.name) + " ", 1),
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(weekDay.formattedDate), 1)
          ]))
        }), 128))
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProjects, (project, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("tr", _hoisted_5, [
              _createElementVNode("td", {
                class: "project-name",
                onClick: ($event: any) => (_ctx.toggleAccordion(project))
              }, _toDisplayString(project.name), 9, _hoisted_6),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.workedHours, (workedHours, index) => {
                return (_openBlock(), _createElementBlock("td", {
                  key: index,
                  workedHours: workedHours,
                  class: "input-column"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((workedHours.value) = $event),
                    class: "hours-input",
                    onChange: ($event: any) => {_ctx.defineUpdatingProject(project, $event, workedHours.date);}
                  }, null, 40, _hoisted_8), [
                    [_vModelText, workedHours.value]
                  ])
                ], 8, _hoisted_7))
              }), 128))
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.phases, (phase, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                phase: phase,
                class: _normalizeClass(["table projects-column", { 'project-phases-is-closed': _ctx.isProjectOpen(phase.id) }])
              }, [
                _createElementVNode("td", null, _toDisplayString(phase.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(phase.workedHours, (workedHours, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: index,
                    workedHours: workedHours,
                    class: "phase-input-column"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((workedHours.value) = $event),
                      class: "hours-input",
                      onChange: ($event: any) => {_ctx.defineUpdatingPhase(phase, project, $event, workedHours.date);}
                    }, null, 40, _hoisted_11), [
                      [_vModelText, workedHours.value]
                    ])
                  ], 8, _hoisted_10))
                }), 128))
              ], 10, _hoisted_9))
            }), 128))
          ], 64))
        }), 128))
      ]),
      _createElementVNode("tr", _hoisted_12, [
        _hoisted_13,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalForDays, (totalForDay, index) => {
          return (_openBlock(), _createElementBlock("td", {
            key: index,
            totalForDay: totalForDay,
            class: "input-column"
          }, [
            _createElementVNode("input", {
              type: "text",
              value: totalForDay.value,
              class: "hours-input",
              disabled: "true",
              style: {"background-color":"rgb(236, 236, 236)"}
            }, null, 8, _hoisted_15)
          ], 8, _hoisted_14))
        }), 128))
      ])
    ])
  ]))
}